import { render, staticRenderFns } from "./SessionDetail.vue?vue&type=template&id=8dae059e"
import script from "./SessionDetail.vue?vue&type=script&lang=ts"
export * from "./SessionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports